module.exports = __webpack_public_path__ + "img/mockPhotoMin.3d25ce38.png";